/*
 * fn: fetchMoreCombos
 *
 * Fetches a page worth of Combo Preview data
 *
 */
import { type MoreCombosResponse } from '@/defs/apiLegacy/pagePartsResponse'
import { type ComboPreviewType } from '@/defs/combo'
import { type ColorIdType } from '@/defs/mtg'
import { filterCombosByColorId, parseComboPreviewResponse } from '@/utils/comboUtil'
import { fetchApi } from '@/utils/requestUtil'

type Props = {
  colorId?: ColorIdType
  more: string
}

export const fetchMoreCombos = async ({ colorId, more }: Props) => {
  const response = await fetchApi<MoreCombosResponse>({ base: 'jsonCloudflare', path: `/pages/${more}` })
  const moreResponse = response.data.more
  const combos = filterCombosByColorId({
    colorId,
    combos: (response.data.cardlists || [])
      .map((cardList) => {
        const combo = parseComboPreviewResponse({ cardList })
        if (combo === false) console.error(`[Api Util] Error parsing combo with header ${cardList.header}, skipping.`)
        return combo
      })
      .filter((c): c is ComboPreviewType => c !== false),
  })

  return { combos, more: moreResponse }
}
